import { render } from "./ReportGroupsSettings.vue?vue&type=template&id=7019d06d&scoped=true"
import script from "./ReportGroupsSettings.vue?vue&type=script&lang=js"
export * from "./ReportGroupsSettings.vue?vue&type=script&lang=js"

import "./ReportGroupsSettings.vue?vue&type=style&index=0&id=7019d06d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7019d06d"]])

export default __exports__